export class CabeceraEquipoExclusionEntity
    {
        constructor(
        public CodigoUsuario?: number,
        public CodigoPoliza?: string,
        public CodigoCiudad?: number,
        public CodigoRamo?: string,
        public CodigoAseguradora?: number,
        public RolEmpleado?: number,
        public CodigoUnidad?: number,        
        public CodigoCliente?: number,
        public EquipoExclusion?: EquipoExclusionEntity[],
        public Observaciones?: string
        
        ){}        
    }

export class EquipoExclusionEntity
    {
        constructor(
        public Marca?: string,
        public Modelo?: string,
        public Motor?: string,
        public Chasis?: string,
        public Placa?: string,
        public Anio?: number,
        public NumeroSerie?: string,
        public NombreUsuario?: string,
        public NumeroTelefono?: string,
        public CodigoEquipo?: number,
        public EstadoSolicitud?: number,
        public EstadoActual?: number
        ){}        
    }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/equipos_exclusion_entity.ts